import type { HTMLAttributes } from 'react'

export type AvatarProps = HTMLAttributes<HTMLSpanElement> & {
  name: string
  shape?: 'circle' | 'rounded'
  size?: 'sm' | 'md'
}

export function Avatar({ name, shape = 'circle', size = 'md', className = '', ...props }: AvatarProps) {
  const initial = Array.from(name.trim())[0] || '客'
  return (
    <span
      className={`grid shrink-0 place-items-center bg-[var(--color-primary-soft)] font-bold text-[var(--color-primary)] ${size === 'sm' ? 'h-8 w-8 text-xs' : 'h-9 w-9 text-sm'} ${shape === 'rounded' ? 'rounded-[var(--radius-md)]' : 'rounded-[var(--radius-pill)]'} ${className}`.trim()}
      aria-hidden="true"
      {...props}
    >
      {initial}
    </span>
  )
}
